import { ICommonSettings, ICrewAgentTool } from "@kuika/kuika-cl-model";
import { Form, FormInstance } from "antd/es";
import _ from "lodash";
import { createRef, PureComponent, ReactNode } from "react";
import { KModal } from "../../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../../ui-kit/k-modal/k-modal-footer";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { getMcpConfigOptions, IMcpConfigOption } from "./ai-agent-helper";
import "./ai-agent-modals.scss";

interface IAiAgentMcpModalProps {
  header?: string;
  closeModal: any;
  showModal: boolean;
  mcpTool?: ICrewAgentTool;
  commonSettings: ICommonSettings;
  isLoading?: boolean;
  handleSubmit: (mcpTool: ICrewAgentTool) => void;
  handleOpenConfigModal: (mcpTool: ICrewAgentTool) => void;
}

interface IAIAgentMcpModalState {}

export class AIAgentMcpModal extends PureComponent<IAiAgentMcpModalProps, IAIAgentMcpModalState> {
  formRef = createRef<FormInstance>();

  // Both the dropdown's ADD NEW header and a row's settings glyph open the same config modal;
  // the row passes the config it stands for, the header passes none (a brand-new config).
  openConfigModal = (settingsId: string | undefined): void => {
    this.props.handleOpenConfigModal({
      settingsId,
      name: this.props.mcpTool?.name!,
      mcpConfigName: this.props.mcpTool?.mcpConfigName!
    });
  };

  // Row markup and its settings glyph are the ones the antd Option carried, moved verbatim so
  // the dropdown looks the same; only the option's host changed.
  renderConfigOption = (item: IMcpConfigOption): ReactNode => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: 4,
        alignItems: "center",
        height: 30
      }}
    >
      <span>{item.name}</span>
      {item.id && (
        <div onClick={() => this.openConfigModal(item.id)} style={{ marginRight: 8, height: 30 }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            style={{ paddingTop: 4 }}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.68207 10.3319C5.27013 9.97316 5 9.41271 5 8.76192C5 8.11112 5.27013 7.55067 5.68207 7.19198C5.93769 6.9694 6.24099 6.84488 6.55556 6.76415L6.55555 4.95239C6.55258 4.74631 6.66311 4.55463 6.84481 4.45074C7.02652 4.34685 7.25126 4.34685 7.43296 4.45074C7.61467 4.55463 7.7252 4.74631 7.72222 4.95239L7.72222 6.76415C8.03679 6.84488 8.34009 6.9694 8.5957 7.19198C9.00764 7.55067 9.27778 8.11112 9.27778 8.76192C9.27778 9.41271 9.00764 9.97316 8.5957 10.3319C8.34009 10.5544 8.03679 10.6789 7.72222 10.7597L7.72222 19.0476C7.7252 19.2537 7.61467 19.4454 7.43296 19.5493C7.25126 19.6532 7.02652 19.6532 6.84481 19.5493C6.66311 19.4454 6.55258 19.2537 6.55556 19.0476L6.55556 10.7597C6.24099 10.6789 5.93769 10.5544 5.68207 10.3319ZM6.45681 8.04614C6.28542 8.19538 6.16667 8.39684 6.16667 8.76192C6.16667 9.127 6.28542 9.32845 6.45681 9.47769C6.62821 9.62693 6.87963 9.7143 7.13889 9.7143C7.39815 9.7143 7.64957 9.62693 7.82096 9.47769C7.99236 9.32845 8.11111 9.12699 8.11111 8.76192C8.11111 8.39684 7.99236 8.19538 7.82096 8.04614C7.64957 7.8969 7.39815 7.80953 7.13889 7.80953C6.87963 7.80953 6.62821 7.8969 6.45681 8.04614ZM9.86111 15.2381C9.86111 15.8889 10.1312 16.4494 10.5432 16.808C10.7988 17.0306 11.1021 17.1551 11.4167 17.2359L11.4167 19.0476C11.4137 19.2537 11.5242 19.4454 11.7059 19.5493C11.8876 19.6532 12.1124 19.6532 12.2941 19.5493C12.4758 19.4454 12.5863 19.2537 12.5833 19.0476L12.5833 17.2359C12.8979 17.1551 13.2012 17.0306 13.4568 16.808C13.8688 16.4494 14.1389 15.8889 14.1389 15.2381C14.1389 14.5873 13.8688 14.0269 13.4568 13.6682C13.2012 13.4456 12.8979 13.3211 12.5833 13.2403L12.5833 4.95239C12.5863 4.74631 12.4758 4.55463 12.2941 4.45074C12.1124 4.34685 11.8876 4.34685 11.7059 4.45074C11.5242 4.55463 11.4137 4.74631 11.4167 4.95239L11.4167 13.2403C11.1021 13.3211 10.7988 13.4456 10.5432 13.6682C10.1312 14.0269 9.86111 14.5873 9.86111 15.2381ZM11.3179 14.5223C11.1465 14.6716 11.0278 14.873 11.0278 15.2381C11.0278 15.6032 11.1465 15.8046 11.3179 15.9539C11.4893 16.1031 11.7407 16.1905 12 16.1905C12.2593 16.1905 12.5107 16.1031 12.6821 15.9539C12.8535 15.8046 12.9722 15.6032 12.9722 15.2381C12.9722 14.873 12.8535 14.6716 12.6821 14.5223C12.5107 14.3731 12.2593 14.2857 12 14.2857C11.7407 14.2857 11.4893 14.3731 11.3179 14.5223ZM14.7222 9.52382C14.7222 10.1746 14.9924 10.7351 15.4043 11.0938C15.6599 11.3163 15.9632 11.4409 16.2778 11.5216L16.2778 19.0476C16.2748 19.2537 16.3853 19.4454 16.567 19.5493C16.7487 19.6532 16.9735 19.6532 17.1552 19.5493C17.3369 19.4454 17.4474 19.2537 17.4444 19.0476L17.4444 11.5216C17.759 11.4409 18.0623 11.3163 18.3179 11.0938C18.7299 10.7351 19 10.1746 19 9.52382C19 8.87303 18.7299 8.31258 18.3179 7.95388C18.0623 7.7313 17.759 7.60679 17.4444 7.52605L17.4444 4.95239C17.4474 4.74631 17.3369 4.55463 17.1552 4.45074C16.9735 4.34685 16.7487 4.34685 16.567 4.45074C16.3853 4.55463 16.2748 4.74631 16.2778 4.95239L16.2778 7.52605C15.9632 7.60679 15.6599 7.7313 15.4043 7.95388C14.9924 8.31258 14.7222 8.87303 14.7222 9.52382ZM16.179 8.80805C16.0076 8.95729 15.8889 9.15874 15.8889 9.52382C15.8889 9.8889 16.0076 10.0904 16.179 10.2396C16.3504 10.3888 16.6019 10.4762 16.8611 10.4762C17.1204 10.4762 17.3718 10.3888 17.5432 10.2396C17.7146 10.0904 17.8333 9.8889 17.8333 9.52382C17.8333 9.15874 17.7146 8.95729 17.5432 8.80805C17.3718 8.65881 17.1204 8.57144 16.8611 8.57144C16.6019 8.57144 16.3504 8.65881 16.179 8.80805Z"
              fill="#246EFF"
            />
          </svg>
        </div>
      )}
    </div>
  );

  onFinish = (values: any) => {
    const mcpTool = _.cloneDeep(this.props.mcpTool);
    if (!mcpTool) return;
    mcpTool.settingsId = values.value;
    this.props.handleSubmit(mcpTool);
  };

  onFinishFailed = (errorInfo: any) => {};

  handleLoadSetting = () => {
    this.formRef.current?.setFieldsValue({ value: this.props.mcpTool?.settingsId });
  };

  componentDidMount(): void {
    this.handleLoadSetting();
  }

  componentDidUpdate(
    prevProps: Readonly<IAiAgentMcpModalProps>,
    prevState: Readonly<IAIAgentMcpModalState>,
    snapshot?: any
  ): void {
    if (prevProps.showModal === false && this.props.showModal === true) {
      this.handleLoadSetting();
    }
  }

  render() {
    if (!this.props.mcpTool?.mcpConfigName) return null;
    const options = getMcpConfigOptions(this.props.commonSettings, this.props.mcpTool.mcpConfigName);
    return (
      <KModal
        className="config-manager__modal"
        showModal={this.props.showModal}
        closeModal={this.props.closeModal}
        header={this.props.header || "MCP setting"}
        width={600}
        centered={true}
        bodyStyle={{ padding: 0 }}
        isLoading={this.props.isLoading}
        footer={<KModalFooter submitLabel="Save" onSubmit={() => this.formRef.current?.submit()} />}
      >
        <Form
          name="settingsForm"
          ref={this.formRef}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          style={{ height: "100%" }}
        >
          {/* Was `<Row><Col xs={24}>` — a single full-width antd column, i.e. a plain block. */}
          <div className="kuika_app-settings__content__container kuika_app-settings__content__container__passwords kuika-ai-agent-mcp-modal__body">
            <div className="passwords__property">
              <span className="property__text">
                Configuration
                <span className="property__required">*</span>
              </span>
              <Form.Item
                name="value"
                style={{ width: 380 }}
                rules={[{ required: true, message: "Please select a configuration" }]}
              >
                <KuikaSelectbox
                  className="property__select"
                  placeholder="Choose Configuration"
                  style={{ width: "100%" }}
                  overlayClassName="config-manager__property__dropdown"
                  dropdownHeader="ADD NEW"
                  onDropdownHeaderClick={() => this.openConfigModal(undefined)}
                  notFoundContent={<></>}
                  options={(options ?? []).map((item: IMcpConfigOption): KuikaSelectboxOption => ({
                    key: item.id,
                    value: item.id,
                    label: this.renderConfigOption(item)
                  }))}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </KModal>
    );
  }
}
